import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'

import { SharingGroup } from '../models'
import { SharingGroupApi } from '../apis'
import { SetVideoGroups, AddVideoGroup, UpdateVideoGroup, DestroyVideoGroup, SetVideoMyGroup } from '../actions/sharing-group'
import 'rxjs/add/operator/do'
import { Store } from '@ngrx/store'
import { AppState } from '../reducers'

@Injectable()
export class SharingGroupService {
  apiPath(videoId: number, groupId = '') {
    return `videos/${videoId}/groups/${groupId}`
  }

  constructor(
    private api: SharingGroupApi,
    private store: Store<AppState>,
  ) { }

  index(videoId: number): Observable<SharingGroup[]> {
    return this.api.index(videoId)
      .do(l => this.store.dispatch(new SetVideoGroups(videoId, l)))
  }

  create(videoId: number, name: string): Observable<SharingGroup> {
    return this.api.create(videoId, name)
      .do(g => this.store.dispatch(new AddVideoGroup(videoId, g)))
  }

  update(videoId: number, groupId: number, name: string): Observable<SharingGroup> {
    return this.api.update(videoId, groupId, name)
      .do(g => this.store.dispatch(new UpdateVideoGroup(videoId, g)))
  }

  destroy(videoId: number, groupId: number): Observable<any> {
    return this.api.destroy(videoId, groupId)
      .do(_ => this.store.dispatch(new DestroyVideoGroup(videoId, groupId)))
  }

  join(videoId: number, groupId: number, userId: number = null): Observable<SharingGroup> {
    return this.api.join(videoId, groupId, userId)
      .do(g => this.store.dispatch(new UpdateVideoGroup(videoId, g)))
      .do(g => this.store.dispatch(new SetVideoMyGroup(videoId, g)))
  }

  leave(videoId: number, groupId: number, userId: number = null): Observable<SharingGroup> {
    return this.api.leave(videoId, groupId, userId)
      .do(g => this.store.dispatch(new UpdateVideoGroup(videoId, g)))
      .do(_ => this.store.dispatch(new SetVideoMyGroup(videoId, null)))
  }

  myGroup(videoId: number): Observable<SharingGroup> {
    return this.api.myGroup(videoId)
      .do(g => this.store.dispatch(new SetVideoMyGroup(videoId, g)))
  }
}



// WEBPACK FOOTER //
// ./src/services/sharing-group.ts